module.exports = __webpack_public_path__ + "img/splashLogo.9b9aa76b.png";